<template>
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col cols="auto" class="headline">Overview</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" @submit.prevent="submit" v-model="valid">
          <v-card class="mb-12">
            <v-card-title>Shop Information</v-card-title>
            <v-card-text>
              <v-text-field name="shopname" label="Title" v-model="ownOverview.name" :rules="stringValidation" :disabled="isSaving"/>
              <v-text-field name="orgname" label="Organisation Name" v-model="ownOverview.org_name" :disabled="isSaving"/>
              <v-text-field name="orgnumber" label="Organisation Number" type="tel" v-model="ownOverview.org_number" :disabled="isSaving"/>
              <v-text-field name="vatnumber" label="VAT Registration Number" type="tel" v-model="ownOverview.vat_number" :disabled="isSaving"/>
              <v-textarea auto-grow rows="1" name="contact" label="Contact" type="tel" v-model="ownOverview.contact" :disabled="isSaving"/>
              <image-input
                label="Image"
                v-model="image"
                :crop-width="450"
                :crop-height="450"
                :crop-clamp="true"
                :quality="0.8"
                ouput-type="jpeg"
                class="mt-0"
                :disabled="isSaving"
              ></image-input>
            </v-card-text>

            <v-card-title>Messages</v-card-title>
            <v-card-text>
              <v-textarea
                auto-grow
                rows="1"
                name="startdialog"
                label="Open message (Shown in a dialog when opening the shop)"
                v-model="ownOverview.message_startup"
                :disabled="isSaving"
              />
              <v-textarea
                auto-grow
                rows="1"
                name="message_order_received"
                label="Message for 'Order received'"
                v-model="ownOverview.message_order_received"
                :disabled="isSaving"
                messages="Available to insert: amount, dateCreated, datePaid, operatorName, deliveryTime"
                class="mb-8"
              />
              <v-textarea
                auto-grow
                rows="1"
                name="message_order_pickup"
                label="Message for 'Order ready to pick up'"
                v-model="ownOverview.message_order_pickup"
                placeholder="Order klar, avhämtas vid #{deviceName}"
                :disabled="isSaving"
                messages="Available to insert: deviceName, amount, dateCreated, datePaid, operatorName, deliveryTime"
              />
            </v-card-text>

            <v-card-title>Settings</v-card-title>
            <v-card-text>
              <time-input
                label="Take Z-Report at"
                v-model="ownOverview.zreport_time"
                placeholder="03:00"
                messages="Time in day that Z-Report will be created. Rounded to nearest full or half hour"
              ></time-input>
            </v-card-text>

            <v-card-text>
              <v-expansion-panels flat hover multiple v-model="optionsExpanded">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 title">Advanced</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <h3 class="mb-2 text--secondary">Online point of sale</h3>

                    <p class="mb-4 text--secondary">Settings for the online point of sale used for purchases made from the app.</p>

                    <v-text-field
                      label="Online point of sale Id"
                      v-model="ownOverview.online_point_of_sale_id"
                      placeholder="FTP001"
                      autocomplete="off"
                    ></v-text-field>

                    <v-text-field
                      label="Online POS control unit Id"
                      v-model="ownOverview.online_pos_control_unit_id"
                      placeholder="RIHTT..."
                      autocomplete="off"
                    ></v-text-field>

                    <v-text-field
                      label="Online POS manufacturing number"
                      v-model="ownOverview.online_pos_manufacturer_number"
                      autocomplete="off"
                    ></v-text-field>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>

            <v-divider />

            <v-card-title>
              <v-btn depressed color="primary" type="submit" :disabled="!valid" :loading="isSaving">Save</v-btn>
            </v-card-title>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ImageInput} from 'dync-imageinput';
import {TimeInput} from 'dync-datetime';

export default {
  data () {
    return {
      ownOverview: {},
      imageName: 'dync-appshop-header.jpg',
      image: null,
      hadImage: false,
      valid: true,
      stringValidation: [v => !!v || 'Cannot be empty']
    }
  },
  watch: {
    overview (newVal) {
      this.setOwnOverview(newVal);
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['overviews.update', 'overviews.create']);
    },
    overview () {
      const items = this.$store.getters['overviews/items'];
      return items.length > 0 ? items[0] : null;
    }
  },
  methods: {
    submit () {
      const item = Object.assign({}, this.ownOverview);

      if (this.image instanceof Blob) {
        item.attachments = [{
          name: this.imageName,
          file: this.image
        }];
      }
      if (!this.image && this.hadImage) {
        item.attachments_remove = [this.imageName];
      }


      var promise;
      if (this.ownOverview.id) {
        promise = this.$store.dispatch('overviews/updateItem', item);
      } else {
        promise = this.$store.dispatch('overviews/createItem', item);
      }
      promise.then(() => {
        this.$snackbar({message: 'Overview saved!', theme: 'success'});
      }).catch((error) => {
        console.error(error);
        this.$snackbar({message: 'Could not save overview', theme: 'error'});
      })
    },
    setOwnOverview (overview) {
      this.image = null;
      this.ownOverview = Object.assign({}, overview);
      this.hadImage = false;
      if (this.ownOverview.attachment_names.indexOf(this.imageName) != -1) {
        this.hadImage = true;
        this.image = this.$store.getters['overviews/getAttachmentUrl'](overview.id, this.imageName);
      }
    }
  },
  mounted () {
    if (this.overview) {
      this.setOwnOverview(this.overview);
    }
  },
  components: {
    ImageInput,
    TimeInput
  }
}
</script>

<style lang="scss" scoped>
  .overview__image-uploader {
    height: 500px;
  }
</style>
